export default __webpack_public_path__ + "static/media/bezos1.aa1fe341.png";